import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('bank-account.routes.index') + '/:reseller_id',
        name: i18n.t('bank-account.routes.index'),
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: i18n.t('bank-account.routes.index') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('bank-account.routes.create'),
        name: i18n.t('bank-account.routes.create'),
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: i18n.t('bank-account.routes.index') },
                    disable: false,
                },
                {
                    text: i18n.t('bank-account.breadcrumbs.create'),
                    to: { name: i18n.t('bank-account.routes.create') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('bank-account.routes.edit') + '/:id',
        name: i18n.t('bank-account.routes.edit'),
        component: () =>
            import(
                /* webpackChunkName: "bank-accounts" */ '@/views/bank-accounts/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('bank-account.breadcrumbs.index'),
                    to: { name: i18n.t('bank-account.routes.index') },
                    disable: false,
                },
                {
                    text: i18n.t('bank-account.breadcrumbs.edit'),
                    to: { name: i18n.t('bank-account.routes.edit') },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
